import RelatorioAnexoModal from '@components/Modals/Admin/RelatorioAnexoModal/Index';
import RelatorioViewerModal from '@components/Modals/Shared/RelatorioViewerModal/Index';
import RenderIfStatusAndRole from '@components/UI/RenderIfStatusAndRole/Index';
import ButtonComp from '@components/UI/Button/Index';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { carregarRelatorios } from '@store/slices/relatoriosSlice';
import { perfisAdmin, perfisTodos } from '@utils/auth/perfis';

export default function RelatorioHandler({
  idSolicitacao,
  idProcesso,
  idUnidadeGerencia,
  codigoProcesso,
  flagAuditoria,
  relatoriosExistentes
}) {
  const dispatch = useDispatch();

  // Estados separados para cada modal
  const [visibleAnexo, setVisibleAnexo] = useState(false);
  const [visibleViewer, setVisibleViewer] = useState(false);

  // dispara sempre que relatoriosExistentes mudar
  useEffect(() => {
    const key = `${idProcesso}-${idUnidadeGerencia}`
    dispatch(carregarRelatorios({ key, relatorios: relatoriosExistentes }))
  }, [dispatch, idProcesso, idUnidadeGerencia, relatoriosExistentes])

  // Ações para modal de anexo
  const openModalAnexo = () => setVisibleAnexo(true);
  const closeModalAnexo = () => setVisibleAnexo(false);

  // Ações para modal de visualização
  const openModalViewer = () => setVisibleViewer(true);
  const closeModalViewer = () => setVisibleViewer(false);

  return (
     <>
      <RenderIfStatusAndRole
        idSolicitacao={idSolicitacao}
        allowedStatuses={[4]}
        allowedRoles={perfisAdmin}
        flagAuditoria={flagAuditoria}
        onlyIfAuditoria={true}
      >
        <ButtonComp
          title="ANEXAR RELATÓRIO"
          type="button"
          onClick={openModalAnexo}
          buttonColor="#125578"
          classnameIcon="fa-solid fa-paperclip"
          hoverMessage="Botão exclusivo para anexar relatórios"
        />
        <RelatorioAnexoModal
          visible={visibleAnexo}
          closeModal={closeModalAnexo}
          idSolicitacao={idSolicitacao}
          idProcesso={idProcesso}
          idUnidadeGerencia={idUnidadeGerencia}
          codigoProcesso={codigoProcesso}
          relatoriosExistentes={relatoriosExistentes}
        />
      </RenderIfStatusAndRole>

      <RenderIfStatusAndRole
        idSolicitacao={idSolicitacao}
        allowedStatuses={[5, 6, 7]}
        allowedRoles={perfisTodos}
        flagAuditoria={flagAuditoria}
        onlyIfAuditoria={true}
      >
        <ButtonComp
          title="VISUALIZAR RELATÓRIO"
          type="button"
          onClick={openModalViewer}
          buttonColor="#125578"
          classnameIcon="fa-solid fa-eye"
          hoverMessage="Visualizar relatório anexado à solicitação"
        />
        <RelatorioViewerModal
          visible={visibleViewer}
          closeModal={closeModalViewer}
          idProcesso={idProcesso}
          idUnidadeGerencia={idUnidadeGerencia}
        />
      </RenderIfStatusAndRole>
    </>
  );
}
